<template>
  <!-- eslint-disable max-len -->
  <button
    class="btn"
    :disabled="disabled"
    :class="{
      primary: color === 'primary',
      destructive: color === 'destructive',
      warning: color === 'warning',
      outline,
      plain,
      small,
      hover,
      normal,
      'no-focus': noFocus,
    }"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    disabled: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    outline: {
      type: Boolean,
    },
    plain: {
      type: Boolean,
    },
    noFocus: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    hover: {
      type: Boolean,
    },
    normal: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";

@mixin button-color($class, $fg, $bg) {
  &.#{$class} {
    @include bg-disabled($fg, $bg);

    &.outline {
      @include outline($bg);
    }

    &.plain {
      border: none;
      background: transparent;
      color: $bg;
      margin: 0;
      padding: 0;
    }

    &.normal {
      font-weight: 400;
    }

    &.small {
      font-size: 12px;
      padding: 8px 16px;
    }

    &:focus {
      box-shadow: none;
    }
  }
}

button.btn {
  padding: 14px 30px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  outline: none;

  // Optional primary handle hover effects *currently still using legacy styles
  &.primary:hover {
    background-color: #0260b2;
    border-color: #025aa5;
  }

  img {
    vertical-align: middle;
  }

  @include button-color(primary, $primary-fg-color, $primary-color);
  @include button-color(destructive, $danger-fg-color, $danger-color);
  @include button-color(warning, $warning-fg-color, $warning-color);
}
</style>
